// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZMwm","icon":"styles_icon__2jsXj"};